(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ht-footer"] && !Shopify.designMode) return;
  try {
    
(() => {
function initializeHabitStore() {
  if (window.habitStoreCleanup) window.habitStoreCleanup();
  const controller = new AbortController();
  const signal = controller.signal;
  const config = window.HabitStore || {};
  const copy = (key, fallback) => config.messages?.[key] || fallback;
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const listen = (el, type, cb, options = {}) => el?.addEventListener(type, cb, { ...options, signal });
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let motionOff = reduced.matches;
  let toastTimer;
  let hasItem = false;
  let frame;
  let revealObserver;
  let stickyObserver;
  const initial = [[1,1,1,1,0,1,1],[1,1,0,1,1,0,1],[1,1,1,1,1,1,0],[1,0,1,1,1,0,1],[1,1,1,0,1,1,1]];
  try { if (localStorage.getItem('habit-store-motion') === 'off') motionOff = true; } catch {}
  function announce(message) {
    const toast = $('.toast');
    if (!toast) return;
    clearTimeout(toastTimer);
    toast.textContent = message;
    toast.classList.add('visible');
    toastTimer = setTimeout(() => toast.classList.remove('visible'), 2400);
  }
  function syncMotion() {
    document.documentElement.classList.toggle('motion-off', motionOff);
    $$('.motion-toggle').forEach(button => {
      button.textContent = motionOff ? copy('motionOff', 'Motion: off') : copy('motionOn', 'Motion: on');
      button.setAttribute('aria-pressed', String(motionOff));
    });
  }
  $$('.motion-toggle').forEach(button => listen(button, 'click', () => {
    motionOff = !motionOff;
    try { localStorage.setItem('habit-store-motion', motionOff ? 'off' : 'on'); } catch {}
    syncMotion();
  }));
  listen(reduced, 'change', () => { motionOff = reduced.matches; syncMotion(); });
  syncMotion();
  if ('IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.07, rootMargin: '0px 0px -25px 0px' });
    document.documentElement.classList.add('motion-ready');
    $$('.reveal').forEach(el => revealObserver.observe(el));
  }
  const hero = $('.habit-cinema, .hero');
  const art = $('.hero-art img, .hero-art-fallback');
  let artReady = false;
  listen(art, 'animationend', () => { artReady = true; art.style.animation = 'none'; });
  listen(hero, 'pointermove', e => {
    if (motionOff || !artReady || e.pointerType !== 'mouse' || innerWidth < 900 || !art) return;
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const rect = hero.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width - .5) * 12;
      const y = ((e.clientY - rect.top) / rect.height - .5) * 9;
      art.style.transform = `translate3d(${x}px,${y}px,0) scale(1.012)`;
    });
  });
  listen(hero, 'pointerleave', () => { if (artReady && art) art.style.transform = ''; });
  const inputs = $$('#habit-rows input');
  function updateMetrics() {
    if (!inputs.length) return;
    const total = inputs.filter(input => input.checked).length;
    const completion = $('#completion-value');
    const done = $('#done-value');
    if (completion) completion.innerHTML = `${Math.round(total / inputs.length * 100)}<span>%</span>`;
    if (done) done.innerHTML = `${total}<span> / ${inputs.length}</span>`;
    const bars = $('#spark-bars');
    if (bars) {
      bars.replaceChildren(...Array.from({ length: 7 }, (_, day) => {
        const count = inputs.filter(input => Number(input.dataset.day) === day && input.checked).length;
        const el = document.createElement('span');
        el.style.setProperty('--bar', `${count / 5 * 100}%`);
        el.title = `${day + 7} Sep: ${count}/5`;
        return el;
      }));
      bars.setAttribute('aria-label', `${copy('dailyCompletion','Daily completion')}: ${Array.from({length:7},(_,day)=>inputs.filter(input=>Number(input.dataset.day)===day&&input.checked).length+'/5').join(', ')}`);
    }
  }
  inputs.forEach(input => listen(input, 'change', updateMetrics));
  $$('.reset-demo').forEach(button => listen(button, 'click', () => {
    inputs.forEach(input => { input.checked = Boolean(initial[Number(input.dataset.habit)][Number(input.dataset.day)]); });
    updateMetrics();
    announce(copy('reset', 'Sample week reset. A fresh perspective.'));
  }));
  updateMetrics();
  const tabs = $$('.demo-tab');
  function selectTab(tab, focus = false) {
    tabs.forEach(item => {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
      item.classList.toggle('active', selected);
      const panel = document.getElementById(item.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
    if (focus) tab.focus();
  }
  tabs.forEach((tab, index) => {
    listen(tab, 'click', () => selectTab(tab));
    listen(tab, 'keydown', e => {
      let next;
      if (['ArrowRight','ArrowDown'].includes(e.key)) next = (index + 1) % tabs.length;
      if (['ArrowLeft','ArrowUp'].includes(e.key)) next = (index - 1 + tabs.length) % tabs.length;
      if (e.key === 'Home') next = 0;
      if (e.key === 'End') next = tabs.length - 1;
      if (next !== undefined) { e.preventDefault(); selectTab(tabs[next], true); }
    });
  });
  const orientTabs = () => $('.demo-tabs')?.setAttribute('aria-orientation', innerWidth <= 900 ? 'horizontal' : 'vertical');
  listen(window, 'resize', orientTabs, { passive: true });
  orientTabs();
  const dialog = $('#cart-drawer');
  function openBag() {
    if (!dialog) return;
    if (!dialog.open) dialog.showModal();
    document.body.style.overflow = 'hidden';
  }
  function closeBag() { dialog?.close(); }
  listen(dialog, 'close', () => { document.body.style.overflow = ''; });
  listen(dialog, 'click', e => {
    if (e.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) closeBag();
    }
  });
  function renderBag() {
    if (!dialog) return;
    const empty = $('.empty-bag', dialog);
    const full = $('.full-bag', dialog);
    if (empty) empty.hidden = hasItem;
    if (full) full.hidden = !hasItem;
    $$('.cart-count').forEach(el => { el.hidden = !hasItem; });
    const count = $('.drawer-count', dialog);
    if (count) count.textContent = hasItem ? '(1)' : '(0)';
  }
  $$('.cart-toggle').forEach(button => listen(button, 'click', () => {
    if (config.shopify) { window.location.assign(config.cartUrl || '/cart'); return; }
    renderBag(); openBag();
  }));
  $$('[data-close-dialog]').forEach(button => listen(button, 'click', closeBag));
  $$('[data-buy]').forEach(button => listen(button, 'click', async e => {
    if (config.shopify) {
      if (config.available && config.productUrl) window.location.assign(config.productUrl + '#purchase');
      else { e.preventDefault(); announce(copy('comingSoon','The tracker is being prepared. Please check back at launch.')); }
      return;
    }
    hasItem = true;
    renderBag();
    openBag();
  }));
  $$('.remove-item').forEach(button => listen(button, 'click', () => {
    hasItem = false;
    renderBag();
    $('.empty-bag [data-buy]')?.focus();
  }));
  if ('IntersectionObserver' in window && $('.mobile-buy-bar') && hero) {
    let pastHero = false;
    let offerVisible = false;
    const updateBar = () => $('.mobile-buy-bar')?.classList.toggle('show', pastHero && !offerVisible);
    stickyObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === hero) pastHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        else offerVisible = entry.isIntersecting;
      });
      updateBar();
    });
    stickyObserver.observe(hero);
    if ($('.offer-card')) stickyObserver.observe($('.offer-card'));
  }
  window.habitStoreCleanup = () => {
    controller.abort();
    revealObserver?.disconnect();
    stickyObserver?.disconnect();
    clearTimeout(toastTimer);
    cancelAnimationFrame(frame);
    document.body.style.overflow = '';
  };
}
initializeHabitStore();
document.addEventListener('shopify:section:load', initializeHabitStore);
})();

document.addEventListener('change',function(e){if(e.target.id==='tracker-variant'){var option=e.target.selectedOptions[0];document.querySelectorAll('[data-price]').forEach(function(el){el.textContent=option.dataset.price;});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ht-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new Map();
  const clamp = (n, a = 0, b = 1) => Math.min(b, Math.max(a, n));
  const smooth = (n) => { const p = clamp(n); return p * p * (3 - 2 * p); };
  const stops = [0, .16, .32, .48, .64, .80];
  const points = [.03, .19, .35, .51, .67, .83];
  function mount(root) {
    if (instances.has(root)) return;
    const abort = new AbortController();
    const signal = abort.signal;
    const on = (target, name, fn, options = {}) => target.addEventListener(name, fn, { ...options, signal });
    const pin = root.querySelector('.hc-pin');
    const stage = root.querySelector('.hc-images');
    const scenes = [...root.querySelectorAll('[data-hc-scene]')];
    const chapters = [...root.querySelectorAll('[data-hc-chapter]')];
    const buttons = [...root.querySelectorAll('[data-hc-jump]')];
    const covers = [...root.querySelectorAll('.hc-tick-cover')];
    const count = root.querySelector('[data-hc-count]');
    const result = root.querySelector('.hc-result');
    const position = root.querySelector('.hc-position');
    const media = matchMedia('(prefers-reduced-motion: reduce)');
    let top = 0, travel = 1, progress = 0, target = 0, frame = 0, lastTime = 0;
    let current = -1, reduced = false, inView = true, chosen = 0, disposed = false;
    let lastWidth = innerWidth, timer;
    let pointerX = 0, pointerY = 0, targetX = 0, targetY = 0;
    root.classList.add('hc-ready');
    function measure() {
      const box = root.getBoundingClientRect();
      top = box.top + scrollY;
      root.style.setProperty('--hc-entry', `${Math.max(0, Math.min(top, top - scrollY))}px`);
      travel = Math.max(1, root.offsetHeight - pin.offsetHeight);
      const bounds = stage.getBoundingClientRect();
      scenes.forEach(scene => {
        const holder = scene.querySelector('.hc-media');
        const scale = Math.max(bounds.width / 2048, bounds.height / 1143);
        const width = 2048 * scale, height = 1143 * scale;
        const focal = Number(scene.dataset.focal) / 100;
        holder.style.width = `${width}px`;
        holder.style.height = `${height}px`;
        holder.style.left = `${(bounds.width - width) * focal}px`;
        holder.style.top = `${(bounds.height - height) * .5}px`;
        holder.style.transformOrigin = `${focal * 100}% 50%`;
      });
      target = reduced ? (chosen === 5 ? 1 : points[chosen]) : clamp((scrollY - top) / travel);
      wake();
    }
    function syncMode() {
      const next = media.matches || document.documentElement.classList.contains('motion-off');
      reduced = next;
      root.classList.toggle('hc-reduced', reduced);
      if (reduced) progress = target = chosen === 5 ? 1 : points[chosen];
      measure();
    }
    function render(p) {
      root.style.setProperty('--hc-progress', p.toFixed(5));
      const weights = scenes.map((_, i) => {
        const enter = i === 0 ? 1 : smooth((p - (stops[i] - .025)) / .050);
        const leave = i === 5 ? 1 : 1 - smooth((p - (stops[i + 1] - .025)) / .050);
        return enter * leave;
      });
      let active = 0;
      weights.forEach((weight, i) => { if (weight > weights[active]) active = i; });
      scenes.forEach((scene, i) => {
        const visible = weights[i] > .001;
        scene.style.visibility = visible ? 'visible' : 'hidden';
        const imageEnter = i === 0 ? 1 : smooth((p - (stops[i] - .025)) / .050);
        scene.style.opacity = visible ? imageEnter.toFixed(4) : '0';
        const local = clamp((p - stops[i] + .04) / (i === 5 ? .24 : .20));
        const zoom = reduced ? 1 : 1.014 + .046 * local;
        const x = reduced ? 0 : ((i % 2 ? -1 : 1) * (local - .5) * 9 + pointerX);
        const y = reduced ? 0 : (local - .5) * -5 + pointerY;
        scene.querySelector('.hc-media').style.transform = `translate3d(${x.toFixed(2)}px,${y.toFixed(2)}px,0) scale(${zoom.toFixed(5)})`;
        const chapter = chapters[i];
        const textEnter = i === 0 ? 1 : smooth((p - stops[i]) / .022);
        const textLeave = i === 5 ? 1 : 1 - smooth((p - (stops[i + 1] - .022)) / .022);
        const textWeight = reduced ? Number(i === active) : textEnter * textLeave;
        chapter.style.opacity = textWeight.toFixed(4);
        chapter.style.visibility = textWeight > .001 ? 'visible' : 'hidden';
        chapter.style.transform = reduced ? 'none' : `translateY(${((1 - textWeight) * (i > active ? 12 : -12)).toFixed(2)}px)`;
      });
      if (active !== current) {
        current = active;
        chosen = active;
        root.dataset.current = String(active);
        position.textContent = `${String(active + 1).padStart(2, '0')} / 06`;
        chapters.forEach((chapter, i) => { chapter.classList.toggle('is-active', i === active); chapter.setAttribute('aria-hidden', String(i !== active)); chapter.inert = i !== active; });
        buttons.forEach((button, i) => { button.classList.toggle('is-active', i === active); if (i === active) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current'); });
        result.setAttribute('aria-hidden', String(active !== 5));
        scenes.slice(active, active + 3).forEach(scene => { const img = scene.querySelector('img'); if (img) img.loading = 'eager'; });
      }
      let done = 0;
      covers.forEach((path, i) => {
        const amount = smooth((p - (.835 + i * .0039)) / .020);
        path.style.strokeDashoffset = String(-amount);
        path.style.opacity = amount >= .999 ? '0' : '1';
        if (amount >= .999) done++;
      });
      count.textContent = String(done);
      root.dataset.checked = String(done);
      root.style.setProperty('--hc-completion', String(done / covers.length));
      buttons.forEach((button, i) => {
        const end = i === 5 ? 1 : stops[i + 1];
        const fill = clamp((p - stops[i]) / (end - stops[i]));
        button.style.setProperty('--step-fill', String(fill));
        button.classList.toggle('is-complete', i === 5 ? done === covers.length : p >= end - .045);
      });
    }
    function tick(time) {
      frame = 0;
      if (disposed || document.hidden) return;
      const dt = Math.min(64, lastTime ? time - lastTime : 16);
      lastTime = time;
      const blend = reduced ? 1 : 1 - Math.exp(-dt / 75);
      progress += (target - progress) * blend;
      pointerX += (targetX - pointerX) * blend;
      pointerY += (targetY - pointerY) * blend;
      if (Math.abs(target - progress) < .000015) progress = target;
      render(progress);
      if (Math.abs(target - progress) > .000015 || Math.abs(targetX - pointerX) > .02 || Math.abs(targetY - pointerY) > .02) wake();
    }
    function wake() { if (!frame && !disposed && !document.hidden) frame = requestAnimationFrame(tick); }
    const observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; root.classList.toggle('hc-in-view', inView); if (inView) { measure(); wake(); } }, { threshold:0 });
    observer.observe(root);
    const resize = new ResizeObserver(() => { clearTimeout(timer); timer = setTimeout(measure, 60); });
    resize.observe(stage);
    const motionObserver = new MutationObserver(syncMode);
    motionObserver.observe(document.documentElement, { attributes:true, attributeFilter:['class'] });
    on(window, 'scroll', () => { if (reduced) return; root.style.setProperty('--hc-entry', `${Math.max(0, Math.min(top, top - scrollY))}px`); target = clamp((scrollY - top) / travel); if (inView || progress !== target) wake(); }, { passive:true });
    on(window, 'resize', () => { if (innerWidth !== lastWidth) { lastWidth = innerWidth; measure(); } }, { passive:true });
    on(window, 'pageshow', measure);
    on(document, 'visibilitychange', () => { if (!document.hidden) { lastTime = 0; measure(); } });
    on(media, 'change', syncMode);
    on(pin, 'pointermove', e => { if (reduced || e.pointerType !== 'mouse' || innerWidth < 1000) return; const box = pin.getBoundingClientRect(); targetX = (e.clientX / box.width - .5) * 7; targetY = ((e.clientY - box.top) / box.height - .5) * 5; wake(); }, { passive:true });
    on(pin, 'pointerleave', () => { targetX = targetY = 0; wake(); });
    buttons.forEach((button, i) => on(button, 'click', () => {
      chosen = i;
      if (reduced) { progress = target = i === 5 ? 1 : points[i]; render(progress); }
      else window.scrollTo({ top:top + points[i] * travel, behavior:'smooth' });
    }));
    const cleanup = () => { disposed = true; abort.abort(); observer.disconnect(); resize.disconnect(); motionObserver.disconnect(); cancelAnimationFrame(frame); clearTimeout(timer); instances.delete(root); };
    instances.set(root, cleanup);
    syncMode();
    render(target);
    progress = target;
  }
  const initialize = () => document.querySelectorAll('[data-habit-cinema]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once:true }); else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => { instances.forEach((cleanup, root) => { if (event.target.contains(root)) cleanup(); }); });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-catalog"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mount = scope => scope.querySelectorAll('[data-lm-catalog]').forEach(catalog => {
    if (catalog.dataset.lmReady) return;
    catalog.dataset.lmReady = 'true';
    const cards = [...catalog.querySelectorAll('[data-lm-card]')];
    const buttons = [...catalog.querySelectorAll('[data-lm-filter]')];
    const input = catalog.querySelector('[data-lm-search]');
    let selected = 'all';
    const update = () => {
      const term = input.value.toLocaleLowerCase().trim();
      let count = 0;
      cards.forEach(card => {
        const show = (selected === 'all' || selected === card.dataset.lmCard) && card.dataset.lmSearchText.toLocaleLowerCase().includes(term);
        card.hidden = !show;
        if (show) count++;
      });
      catalog.querySelector('[data-lm-empty]').hidden = count > 0;
    };
    buttons.forEach(button => button.addEventListener('click', () => {
      selected = button.dataset.lmFilter;
      buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      update();
    }));
    input.addEventListener('input', update);
    input.addEventListener('search', update);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), {once:true});
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-postpartum"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lm-guide-gallery')) {
  customElements.define('lm-guide-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-guide-index]');
        if (!button || !this.contains(button)) return;
        const index = button.dataset.guideIndex;
        this.querySelectorAll('[data-guide-panel]').forEach(panel => { panel.hidden = panel.dataset.guidePanel !== index; });
        this.querySelectorAll('button[data-guide-index]').forEach(item => { item.setAttribute('aria-pressed', String(item === button)); });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
